import React, { useState, useEffect } from 'react';

import BaseFrame from '@components/settings/components/modules/baseFrame';

import { TimeZoneProps, TimeZoneStorage } from '@components/settings/v2/structure/connector/productionConnectorSetup/interfaces';

export default (props: any) => {
  const {
    getTimezone,
    setMode,
    MODES,
    updateDataHistory,
    data: { timeZoneWindows },
  }: TimeZoneProps = props;

  const [data, setData] = useState<TimeZoneStorage[]>([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(timeZoneWindows || '');

  useEffect(() => {
    (async () => {
      const d = await getTimezone();
      if (d) {
        setData(d.map((i) => ({ name: i.name, value: i.id })));
      }
      setLoading(false);
    })();
  }, []);

  const onSelect = (item: TimeZoneStorage) => {
    setSelected(item.value);
  };

  const onCancel = () => {
    setMode(MODES.CONNECTOR_DETAILS);
  };

  const onSubmit = async () => {
    updateDataHistory('timeZoneWindows', selected);
    setMode(MODES.CONNECTOR_DETAILS);
  };

  return (
    <BaseFrame
      {...{
        ...props,
        loading,
        data,
        onCancel,
        onSelect,
        onSubmit,
        header: 'Time Zone',
        selected,
        hide: () => {},
      }}
    />
  );
};
